export default __webpack_public_path__ + "assets/images/1.d5f325.webp";